module.exports = __webpack_public_path__ + "img/ic_add_special_num.9c497b93.svg";